import React from "react";

import { FormattedMessage, useIntl } from "react-intl";

import { CwsA } from "cms-web-styleguide/dist/components/CwsA/CwsA";
import { CwsAccordion } from "cms-web-styleguide/dist/components/CwsAccordion/CwsAccordion";
import { CwsAccordionItem } from "cms-web-styleguide/dist/components/CwsAccordion/CwsAccordionItem/CwsAccordionItem";
import { CwsAccordionItemBody } from "cms-web-styleguide/dist/components/CwsAccordion/CwsAccordionItem/CwsAccordionItemBody/CwsAccordionItemBody";
import { CwsAccordionItemHeader } from "cms-web-styleguide/dist/components/CwsAccordion/CwsAccordionItem/CwsAccordionItemHeader/CwsAccordionItemHeader";
import { CwsDivider } from "cms-web-styleguide/dist/components/CwsDivider/CwsDivider";
import { CwsH3 } from "cms-web-styleguide/dist/components/CwsTypography/CwsH3/CwsH3";
import { CwsH4 } from "cms-web-styleguide/dist/components/CwsTypography/CwsH4/CwsH4";
import { CwsP } from "cms-web-styleguide/dist/components/CwsTypography/CwsP/CwsP";

import { i18n } from "../../i18n/i18n";

const CookiePolicyTab = (props) => {
  const { locale } = props;

  const intl = useIntl();

  return (
    <>
      <CwsH3>
        <FormattedMessage id="popup.tab.label.cookie.policy" />
      </CwsH3>
      <CwsP size="small">
        <FormattedMessage
          id="popup.cookie.policy.description.1"
          values={{
            tallink: (
              <strong>
                <FormattedMessage id="tallink.label" />
              </strong>
            ),
            cookiesPolicy: (
              <strong>
                <FormattedMessage id="popup.tab.label.cookie.policy" />
              </strong>
            ),
          }}
        />
      </CwsP>
      <CwsP size="small">
        <FormattedMessage
          id="popup.cookie.policy.description.2"
          values={{
            link: (
              <CwsA
                inline
                href={intl.formatMessage({
                  id: "popup.cookie.policy.description.2.link",
                })}
                target="_blank"
                size="small"
              >
                {intl.formatMessage({
                  id: "popup.cookie.policy.description.2.link",
                })}
              </CwsA>
            ),
          }}
        />
      </CwsP>

      <CwsDivider className="cws-mt-xs" />

      <CwsAccordion>
        <CwsAccordionItem id="cookie-policy-1">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.cookie.policy.accordion.1.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="popup.cookie.policy.accordion.1.description" />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="cookie-policy-2">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.cookie.policy.accordion.2.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.cookie.policy.accordion.2.description.1" />
            </CwsP>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="popup.cookie.policy.accordion.2.description.2" />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="cookie-policy-3">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.cookie.policy.accordion.3.label" />}
          />
          <CwsAccordionItemBody>
            <CwsH4>
              <FormattedMessage id="popup.cookie.policy.accordion.3.description.1.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.cookie.policy.accordion.3.description.1" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.cookie.policy.accordion.3.description.2.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.cookie.policy.accordion.3.description.2" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.cookie.policy.accordion.3.description.3.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.cookie.policy.accordion.3.description.3" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.cookie.policy.accordion.3.description.4.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage
                id="popup.cookie.policy.accordion.3.description.4"
                values={{
                  linkPrivacyPolicyGoogle: (
                    <CwsA
                      inline
                      href={intl.formatMessage({
                        id: "privacy.policy.google.link",
                      })}
                      size="small"
                      target="_blank"
                    >
                      {intl.formatMessage({
                        id: "privacy.policy.google.name",
                      })}
                    </CwsA>
                  ),
                  linkPrivacyPolicyLinkedIn: (
                    <CwsA
                      inline
                      href={intl.formatMessage({
                        id: "privacy.policy.linkedin.link",
                      })}
                      size="small"
                      target="_blank"
                    >
                      {intl.formatMessage({
                        id: "privacy.policy.linkedin.name",
                      })}
                    </CwsA>
                  ),
                  linkPrivacyPolicyMeta: (
                    <CwsA
                      inline
                      href={intl.formatMessage({
                        id: "privacy.policy.meta.link",
                      })}
                      size="small"
                      target="_blank"
                    >
                      {intl.formatMessage({
                        id: "privacy.policy.meta.name",
                      })}
                    </CwsA>
                  ),
                }}
              />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="cookie-policy-4">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.cookie.policy.accordion.4.label" />}
          />
          <CwsAccordionItemBody>
            {Object.entries(i18n(locale)["popup.cookie.policy.accordion.4.cookies"]).map((cookie, index, arr) => {
              const { description, expiration, name, service } = cookie[1];

              return (
                <React.Fragment key={index}>
                  <CwsP className="cws-mb-xxs-sub" size="tiny">
                    <FormattedMessage id="popup.cookie.policy.accordion.4.service" />
                  </CwsP>
                  <CwsP className="cws-mb-xs" size="small" weight="500">
                    {service}
                  </CwsP>
                  <CwsP className="cws-mb-xxs-sub" size="tiny">
                    <FormattedMessage id="popup.cookie.policy.accordion.4.cookie" />
                  </CwsP>
                  <CwsP className="cws-mb-xs" size="small" weight="500">
                    {name}
                  </CwsP>
                  {description !== "" && (
                    <>
                      <CwsP className="cws-mb-xxs-sub" size="tiny">
                        <FormattedMessage id="popup.cookie.policy.accordion.4.description" />
                      </CwsP>
                      <CwsP className="cws-mb-xs" size="small">
                        {description}
                      </CwsP>
                    </>
                  )}
                  {expiration !== "" && (
                    <>
                      <CwsP className="cws-mb-xxs-sub" size="tiny">
                        <FormattedMessage id="popup.cookie.policy.accordion.4.expiration" />
                      </CwsP>
                      <CwsP size="small">{expiration}</CwsP>
                    </>
                  )}
                  {index + 1 !== arr.length && <CwsDivider className="cws-my-xs" />}
                </React.Fragment>
              );
            })}
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="cookie-policy-5">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.cookie.policy.accordion.5.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="popup.cookie.policy.accordion.5.description" />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
      </CwsAccordion>

      <CwsDivider />
    </>
  );
};

export { CookiePolicyTab };
